<h1 mat-dialog-title>{{ titleText }}</h1>

<mat-dialog-content class="flex! flex-col">
  <p>{{ descriptionText }}</p>

  <div
    class="-mx-6 px-6 max-h-96 overflow-y-auto overflow-x-hidden mt-2 space-y-4 scrollbar-width-thin"
  >
    @if (isMediaGrouped) {
      @for (mediaGroup of data.mediaGroups; track $index) {
        <div>
          <div class="flex items-center gap-1.5 mb-1.5">
            Bestandnaam:
            <span class="text-sm font-medium text-primary-700 truncate">
              {{ mediaGroup.mediaLabel }}
            </span>
          </div>

          @for (
            typeGroup of getMediaGroupTypeSubGroups(mediaGroup);
            track typeGroup.type
          ) {
            <div>
              <div
                class="inline-flex items-center cursor-pointer select-none h-8"
                (click)="toggleTypeGroup(mediaGroup.mediaLabel, typeGroup.type)"
                (keydown.enter)="toggleTypeGroup(mediaGroup.mediaLabel, typeGroup.type)"
                tabindex="0"
                role="button"
              >
                <div
                  class="type-group-toggle-icon"
                  [class.collapsed]="
                    !isTypeGroupExpanded(mediaGroup.mediaLabel, typeGroup.type)
                  "
                >
                  <mat-icon class="flex-none text-gray-500 text-xl/5! py-1 px-0.5"
                    >arrow_drop_down</mat-icon
                  >
                </div>
                <div class="flex gap-1">
                  <span class="text-sm font-medium text-gray-700">
                    {{ typeLabelPlural(typeGroup.type) }}
                  </span>
                  <span class="text-xs text-gray-400"
                    >({{ typeGroup.references.length }})</span
                  >
                </div>
              </div>

              <div
                class="type-group-content"
                [class.collapsed]="
                  !isTypeGroupExpanded(mediaGroup.mediaLabel, typeGroup.type)
                "
              >
                <div class="type-group-content-inner">
                  <div class="border border-gray-300 rounded-sm bg-gray-100">
                    <ul class="list-inside py-2">
                      @for (ref of typeGroup.references; track $index) {
                        <li>
                          <div class="flex items-center px-4 py-2">
                            <div class="flex-auto min-w-0 pr-4">
                              <strong class="block truncate">{{
                                ref.label || ref.filename
                              }}</strong>
                              <span class="block text-gray-500 text-xs truncate">{{
                                ref.unitLabel
                              }}</span>
                            </div>

                            <button
                              class="size-8! p-1.5!"
                              mat-icon-button
                              matTooltip="Ga naar interactie"
                              (click)="navigateToReference(ref)"
                            >
                              <mat-icon
                                class="size-5! text-xl! leading-none! font-medium!"
                                >open_in_new</mat-icon
                              >
                            </button>
                          </div>
                        </li>
                      }
                    </ul>
                    <div
                      class="text-xs text-gray-500 italic px-4 py-2 rounded-b-[inherit] font-medium border-t border-gray-300 bg-gray-200"
                    >
                      @if (typeGroup.type === 'interactions') {
                        Verwijder deze media uit de concepten en publiceer indien nodig
                        opnieuw.
                      } @else if (typeGroup.type === 'scm') {
                        Verwijder deze media uit de signaleringen
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (mediaGroup.totalCount > mediaGroup.references.length) {
            <p class="text-xs text-gray-400 mt-1 pl-1">
              en {{ mediaGroup.totalCount - mediaGroup.references.length }} meer...
            </p>
          }
        </div>
      }
    } @else {
      @for (group of groupedReferences; track group.unitId) {
        <div>
          <div class="flex items-center gap-1">
            Unit:
            <span class="block max-w-40 truncate font-semibold text-primary-700">
              {{ group.unitLabel }}
            </span>
          </div>

          @for (typeGroup of getTypeSubGroups(group); track typeGroup.type) {
            <div>
              <div
                class="inline-flex items-center cursor-pointer select-none h-8"
                (click)="toggleTypeGroup(group.unitId, typeGroup.type)"
                (keydown.enter)="toggleTypeGroup(group.unitId, typeGroup.type)"
                tabindex="0"
                role="button"
              >
                <div
                  class="type-group-toggle-icon"
                  [class.collapsed]="!isTypeGroupExpanded(group.unitId, typeGroup.type)"
                >
                  <mat-icon class="flex-none text-gray-500 text-xl/5! py-1 px-0.5"
                    >arrow_drop_down</mat-icon
                  >
                </div>
                <div class="flex gap-1">
                  <span class="text-sm font-medium text-gray-700">
                    {{ typeLabelPlural(typeGroup.type) }}
                  </span>
                  <span class="text-xs text-gray-400"
                    >({{ typeGroup.references.length }})</span
                  >
                </div>
              </div>

              <div
                class="type-group-content"
                [class.collapsed]="!isTypeGroupExpanded(group.unitId, typeGroup.type)"
              >
                <div class="type-group-content-inner">
                  <div class="border border-gray-300 rounded-sm bg-gray-100">
                    <ul class="list-inside py-2">
                      @for (ref of typeGroup.references; track $index) {
                        <li>
                          <div class="flex items-center px-4 py-2">
                            <div class="flex-auto min-w-0 pr-4">
                              <strong class="block truncate">{{
                                ref.label || ref.filename
                              }}</strong>
                              <!-- @if (hasMultipleMedia) {
                                <span class="block text-gray-500 text-xs">{{ ref.filename }}</span>
                              } -->
                              <span class="block text-gray-500 text-xs">{{
                                ref.filename
                              }}</span>
                            </div>

                            <button
                              class="size-8! p-1.5!"
                              mat-icon-button
                              matTooltip="Ga naar interactie"
                              (click)="navigateToReference(ref)"
                            >
                              <mat-icon
                                class="size-5! text-xl! leading-none! font-medium!"
                                >open_in_new</mat-icon
                              >
                            </button>
                          </div>
                        </li>
                      }
                    </ul>
                    <div
                      class="text-xs text-gray-500 italic px-4 py-2 rounded-b-[inherit] font-medium border-t border-gray-300 bg-gray-200"
                    >
                      @if (typeGroup.type === 'interactions') {
                        Verwijder deze media uit de concepten en publiceer indien nodig
                        opnieuw.
                      } @else if (typeGroup.type === 'scm') {
                        Verwijder deze media uit de signaleringen
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (group.totalCount > group.references.length) {
            <p class="text-xs text-gray-400 mt-1 pl-1">
              en {{ group.totalCount - group.references.length }} meer...
            </p>
          }
        </div>
      }
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Sluiten</button>
  @if (data.deletableCount && data.deletableCount > 0) {
    <button mat-flat-button [mat-dialog-close]="{ deleteRemaining: true }">
      Verwijder overige {{ data.deletableCount }}
      {{ data.deletableCount === 1 ? 'item' : 'items' }}
    </button>
  }
</mat-dialog-actions>
